import { AppState } from 'Store'

const selectBlackList = (state: AppState) => state.iBro.requests.bgBlackList.blackList.entries
const getTotal = (state: AppState) => state.iBro.requests.bgBlackList.blackList.total_entries
const getRequestParams = (state: AppState) => state.iBro.requests.bgBlackList.requestParams

export const bgBlackListSelector = {
	selectBlackList,
	getRequestParams,
	getTotal,
}
